import React, { Component } from 'react';
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context.js';

const getIds = (id) => {
  let projectId = id;
  let personId = '';
  let resourceId = '';
  let secondId = '';

  if (id.includes('-')) {
    projectId = id.split("-")[0];
    secondId = id.split("-")[1];

    if (secondId.includes('@')) {
      personId = secondId;
    } else {
      resourceId = secondId;
    }
  }

  return {
    projectId,
    personId,
    resourceId
  }
}

class LogContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            log: null
        };
    }

    async update() {
        const log_id = this.props.match.params.id;
        const { devmode, setGlobalError } = this.context;
        let res = await fetch(`/api/log/${log_id}`)
        if (res.ok) {
            let log = await res.json();
            devmode && console.log("Log:", log);
            this.setState({
                id: log_id,
                log: log
            });
            return
        }
        const errdata = await res.json();
        const message = `error ${res.status} fetching log ${log_id}: ${errdata.message}`;
        console.log(message);
        setGlobalError(message);
    }

    async getProject() {
        const id = this.props.match.params.id;
        const { projectId } = getIds(id);
        const { devmode, setGlobalError, updateProject } = this.context;
        let res = await fetch(`/api/project/${projectId}`)
        if (res.ok) {
            let proj = await res.json();
            devmode && console.log("Project:", proj);
            updateProject(proj);
            return
        }
        const errdata = await res.json();
        const message = `error ${res.status} fetching project ${projectId}: ${errdata.message}`;
        console.log(message);
        setGlobalError(message);
    }

    componentDidMount() {
        this.update();
        const { project } = this.context;
        if (project === null) {
          this.getProject()
        }
    }

    render() {
        if (!(this.state.id)) {
            return null
        }

        const { projectId, personId, resourceId } = getIds(this.state.id);
        let resourceName = '';
        const { log } = this.state;
        const entries = log.entries.length ? log.entries : [];
        const { project } = this.context;
        if (resourceId && project) {
          resourceName = project.resources[resourceId].name;
        }

        console.log(log);

        return (
            <div style={{padding: "20px"}}>
              <Styles>
                {project && project.title && <h1>Logs for {project.title}</h1>}
                <h2>Project Id {projectId} - {personId && `Person ${personId}`}{resourceId && `Resource ${resourceName}`}</h2>
                <div className="logs">
                    {
                        entries.map(entry => {
                            return (
                                <div key={entry.time_stamp}
                                  className="log-entries">
                                    <div className="log-entry">
                                      <div className="log-label">User</div>
                                      <div className="log-value">{entry.log_user}</div>
                                    </div>
                                    <div className="log-entry">
                                      <div className="log-label">Message</div>
                                      <div className="log-value">{entry.message}</div>
                                    </div>
                                    <div className="log-entry">
                                      <div className="log-label">Time</div>
                                      <div className="log-value">{entry.time_stamp.split(" ")[0]}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
              </Styles>
            </div>
        );
    }
}

export default LogContainer;
